export default __webpack_public_path__ + "static/media/thumbs-up.5914198e.svg";